module.exports = {"533102001":"勐卯街道","533102102":"畹町镇","533102103":"弄岛镇","533102104":"姐相镇","533102202":"户育乡","533102203":"勐秀乡","533102400":"瑞丽农场管理委员会","533102401":"畹町农场管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533102.json
// module id = 2796
// module chunks = 0